import { jsx } from "react/jsx-runtime";
import { CarSelection } from "./selections/CarsSelection/index.js";
import { FlightSelection } from "./selections/FlightsSelection/index.js";
import { HotelSelection } from "./selections/HotelsSelection/index.js";
import { PackageSelection } from "./selections/PackageSelection/index.js";
function RecentSelection(props) {
    switch(props.productType){
        case 'hotels':
            return /*#__PURE__*/ jsx(HotelSelection, {
                ...props
            });
        case 'cars':
            return /*#__PURE__*/ jsx(CarSelection, {
                ...props
            });
        case 'flights':
            return /*#__PURE__*/ jsx(FlightSelection, {
                ...props
            });
        case 'packages':
            return /*#__PURE__*/ jsx(PackageSelection, {
                ...props
            });
        default:
            return null;
    }
}
export { RecentSelection };
